/*
 * Producer -- Jimmy
 * Function -- Mini购物车
 */
import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as index from "../../actions/index";
import * as global from "../../actions/global";

class Search extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      topRightModel: "",
      _static: "https://ssl1.sephorastatic.cn",
      welcomeTip: '',
    };

  }
  componentDidMount() {
    const _homeConfig = this.props._homeConfig;
    // 首页search
    if(_homeConfig && _homeConfig.results && _homeConfig.results.welcomeTip){
      this.setState({
        welcomeTip: _homeConfig.results.welcomeTip
      })
    }
    if (window && window.__INITIAL_ENV__) {
      const envStatic = window.__INITIAL_ENV__.static;
      this.setState({
        _static: envStatic || "https://ssl1.sephorastatic.cn"
      })
    }
  }

  render() {
    const { _static, welcomeTip } = this.state;
    /* 正品承诺广告位 */
    let _topRightPicture = null;
      // _topRightPicture = (
      //   <div className="search-info-content-shopping">
      //     <img src={_static + "/soa/pc/images/20240724_PC_HP_V101_06.png"} alt="" />
      //   </div>
      // );
      
    return (
      <div id="Search">
        <div className="search-info">
          <div className="search-info-content clearFix">
            <div className="search-info-content-text">{welcomeTip}</div>
            <div className="search-info-content-logo">
                <img
                  src={_static + "/soa/pc/images/20240724_PC_HP_V101_03.png"}
                  alt=""
                />
            </div>
            {/* {_topRightPicture} */}
          </div>
        </div>
      </div>
    );
  }
}
export default connect(
  (state) => ({
    _homeConfig: state.homeConfig,
  }),
  (dispatch) => ({
    index: bindActionCreators(index, dispatch),
    global: bindActionCreators(global, dispatch),
    dispatch,
  }),
)(Search);



// WEBPACK FOOTER //
// ./common/components/Search/index.js